import type { CityConfig } from "../city-template/types";

export const clintonIAConfig: CityConfig = {
  city: "Clinton",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "clinton-ia",
  route: "/cities/clinton-ia",
  title: "Emergency Passport Clinton, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Clinton, IA — as fast as 24 hours. Serving Clinton County and Eastern Iowa. A+ BBB rated registered State Dept. courier serving the Gateway to Iowa Mississippi River region. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Clinton, IA",
  heroSubtitle: "Eastern Iowa business trip to Toronto with two weeks notice? Mississippi River cruise and your passport expired? US-30 Gateway to Iowa travelers needing documents fast? We help Clinton residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Clinton%20Iowa%20Mississippi%20River%20city%20Gateway%20to%20Iowa%20historic%20downtown%20brick%20buildings%20riverfront%20promenade%20sawmill%20heritage%20industrial%20riverfront%20skyline%20with%20bridges%20crossing%20the%20Mississippi%20River%20golden%20hour%20warm%20sunset%20light%20professional%20drone%20photography%20soft%20natural%20tones&width=1800&height=700&seq=clinton-ia-hero-2026&orientation=landscape",
  heroImageAlt: "Clinton Iowa Gateway to Iowa Mississippi River city at golden hour",
  geoPosition: "41.8445;-90.1887",
  geoPlacename: "Clinton, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 155 miles east of Clinton via I-88",
  },
  nearbyCitiesZips: [
    { name: "Clinton", zips: "52732" },
    { name: "Fulton", zips: "61252" },
    { name: "DeWitt", zips: "52742" },
    { name: "Maquoketa", zips: "52060" },
    { name: "Davenport", zips: "52801–52807" },
    { name: "Bettendorf", zips: "52722" },
    { name: "Muscatine", zips: "52761" },
    { name: "Camanche", zips: "52730" },
    { name: "Preston", zips: "52069" },
    { name: "Tipton", zips: "52772" },
    { name: "Morrison", zips: "61270" },
    { name: "Sterling", zips: "61081" },
    { name: "Rock Island", zips: "61201" },
    { name: "Moline", zips: "61265" },
    { name: "Dubuque", zips: "52001–52003" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Eastern Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Gateway to Iowa", desc: "Serving Clinton, DeWitt, Maquoketa, and the Mississippi River gateway" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Davenport, IA", route: "/cities/davenport" },
    { name: "Fast passport renewal in Iowa City, IA", route: "/cities/iowa-city" },
    { name: "Emergency passport help in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
    { name: "Urgent passport services in Dubuque, IA", route: "/cities/dubuque" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Passport courier services in Bettendorf, IA", route: "/cities/bettendorf" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Clinton remotely via secure courier. We do not have a walk-in office in Clinton — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Clinton County and Eastern Iowa.",
  fpcOfficeAddress: "801 Grand Ave, Des Moines, Iowa 50309",
  fpcOfficeDistance: "Serving all of Clinton County and the U.S. Route 30 gateway region including Jackson, Cedar, and Scott counties",
  serviceAreaIntro: "From the historic lumber baron mansions and riverfront parkway of Clinton to the charming Dutch heritage of Fulton across the river, from the county seat of DeWitt to the school sports town of Maquoketa, from the industrial riverfront of Camanche to the agricultural communities of Preston and Tipton — Fast Passport Center serves the entire Gateway to Iowa and Eastern Iowa region. We regularly help travelers from Clinton County, Jackson County, and the Quad Cities area get their passports fast without the 155-mile drive to Chicago.",
  nearbyCitiesIntro: "We serve all Clinton neighborhoods and the surrounding Eastern Iowa area including Fulton, DeWitt, Maquoketa, Davenport, Bettendorf, Muscatine, Camanche, Preston, Tipton, and the Illinois communities of Morrison, Sterling, Rock Island, and Moline. If you are anywhere in Clinton County, the U.S. 30 corridor, or the Mississippi River gateway, we have you covered.",
  howItWorksIntro: "Most Clinton travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Clinton travelers often face a 2.5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Clinton and Clinton County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Clinton? Here are the most common ones we hear from Eastern Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Iowa Vital Records (Birth, Death, Marriage)", href: "https://hhs.iowa.gov/vital-records" },
    { icon: "ri-map-pin-line", label: "Clinton County Recorder", href: "https://www.clintoncounty-ia.gov/160/Recorder" },
    { icon: "ri-map-pin-2-line", label: "DeWitt Post Office", href: "https://tools.usps.com/find-location.htm" },
    { icon: "ri-map-pin-line", label: "Maquoketa Post Office", href: "https://tools.usps.com/find-location.htm" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Clinton travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Sharon P.",
      location: "Clinton, IA",
      rating: 5,
      text: "Our Mexico vacation was in 6 days and I realized my passport had expired. Fast Passport Center had my renewal in 30 hours. I never left Clinton. The Gateway to Iowa saved our Cancun trip!",
      service: "Passport Renewal",
    },
    {
      name: "Mike T.",
      location: "Fulton, IL",
      rating: 5,
      text: "Emergency business trip to Dubai with 4 days notice. New passport needed fast. Fast Passport Center got it done in 26 hours. River community travelers — this is the way.",
      service: "New Passport",
    },
    {
      name: "Jennifer K.",
      location: "DeWitt, IA",
      rating: 5,
      text: "Our 8-year-old needed a passport for our Canadian Rockies trip. Fast Passport Center handled the child passport seamlessly. Got it in 4 days. Clinton County families are in good hands.",
      service: "Child Passport",
    },

  ],
  facilities: [
    {
      id: "clinton-ia-1",
      name: "Clinton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 S 1st St",
      city: "Clinton",
      state: "IA",
      zip: "52732",
      phone: "(563) 242-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Clinton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Clinton facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "clinton-ia-2",
      name: "Clinton County Recorder",
      type: "County Recorder Passport Acceptance",
      address: "1900 N 3rd St",
      city: "Clinton",
      state: "IA",
      zip: "52732",
      phone: "(563) 244-0560",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "North Clinton",
      website: "https://www.clintoncounty-ia.gov",
      websiteLabel: "Clinton County Recorder",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "clinton-ia-3",
      name: "DeWitt Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "510 6th Ave",
      city: "DeWitt",
      state: "IA",
      zip: "52742",
      phone: "(563) 659-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles west of Clinton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves DeWitt and western Clinton County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "clinton-ia-4",
      name: "Maquoketa Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "127 S 2nd St",
      city: "Maquoketa",
      state: "IA",
      zip: "52060",
      phone: "(563) 652-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles northwest of Clinton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Jackson County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "clinton-ia-5",
      name: "Fulton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1011 4th St",
      city: "Fulton",
      state: "IL",
      zip: "61252",
      phone: "(815) 589-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles east across the Mississippi",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fulton and Whiteside County, IL. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "clinton-ia-6",
      name: "Davenport Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 W 2nd St",
      city: "Davenport",
      state: "IA",
      zip: "52801",
      phone: "(563) 322-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles south of Clinton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Large Quad Cities facility. Full passport services with extended hours available by appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Clinton photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Clinton County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Clinton applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Eastern Iowa families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Clinton travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Clinton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Clinton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Clinton before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Clinton for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 2.5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Clinton?", a: "Fast Passport Center offers fast passport renewal in Clinton in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Clinton?", a: "The nearest regional passport agency to Clinton is the Chicago Passport Agency, approximately 155 miles east via I-88. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Clinton without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Clinton?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 2.5 hours from Clinton — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Clinton County and Eastern Iowa residents." },
    { q: "Do you serve the entire Gateway to Iowa region?", a: "Absolutely. Fast Passport Center serves the entire Gateway to Iowa and Eastern Iowa region including Clinton, Fulton, DeWitt, Maquoketa, Camanche, and surrounding areas. Our courier service works seamlessly from any address in Clinton County, Jackson County, or the Quad Cities area." },
    { q: "Can I expedite a child passport in Clinton?", a: "Yes. Fast Passport Center expedites child passports in Clinton for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Eastern Iowa families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Clinton with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Clinton", address: "2715 S 25th St, Clinton, IA 52732", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
    { name: "Walgreens — Clinton", address: "300 S 1st St, Clinton, IA 52732", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — Fulton", address: "1011 4th St, Fulton, IL 61252", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walmart Supercenter — DeWitt", address: "1900 S 14th St, DeWitt, IA 52742", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Clinton",
      address: "317 7th Ave S, Clinton, IA 52732",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Davenport",
      address: "1706 E Kimberly Rd, Davenport, IA 52807",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Quad Cities area full service. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Iowa DOT — Maquoketa",
      address: "117 S Main St, Maquoketa, IA 52060",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Jackson County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CWI",
      name: "Clinton Municipal Airport",
      distance: "3 miles south of downtown Clinton",
      address: "2000 S 54th St, Clinton, IA 52732",
      note: "General aviation airport serving Clinton County. About 10 minutes from downtown Clinton.",
      flightUrl: "https://www.clintonia.gov/government/departments/airport",
      flightLabel: "CWI Airport",
      featured: true,
    },
    {
      code: "MLI",
      name: "Quad Cities International Airport",
      distance: "45 miles south of Clinton",
      address: "2200 69th Ave, Moline, IL 61265",
      note: "Regional airport with direct flights to major hubs. About 50 minutes from Clinton.",
      flightUrl: "https://www.qcairport.com/",
      flightLabel: "MLI Airport",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "150 miles east of Clinton",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub. About 2.5 hours from Clinton via I-88.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Airport",
      featured: false,
    },
  ],
};